import { Decimal } from 'decimal.js';

export const INVALID_PRICE = -1;

export function isValidPrice(price) {
  return Number(price) > 0;
}

export function requireValidPrice(price, defaultPrice = 0) {
  return isValidPrice(price) ? price : defaultPrice;
}

export function truncateWithoutRounding({
  amount,
  precision,
  returnDisplayString = false,
}) {
  if (!amount) return '';
  const amountString = amount.toString();
  const [integers, decimals] = amountString.split('.');

  // Format integers with commas if returnDisplayString is true
  let formattedIntegers = integers;
  if (returnDisplayString) {
    const num = parseInt(integers);
    if (num >= 1e12) {
      // Trillion
      const trillions = (num / 1e12).toFixed(0);
      formattedIntegers = `${trillions.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}T`;
    } else {
      formattedIntegers = integers.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
  if (decimals) {
    const truncatedDecimals =
      decimals.length > precision ? decimals.substring(0, precision) : decimals;
    return `${formattedIntegers}.${truncatedDecimals}`;
  } else {
    return `${formattedIntegers}`;
  }
}

export function toCrypto({ conversion, amount, precision }) {
  if (!isValidPrice(conversion)) return 0;
  return Decimal.div(amount, conversion).toFixed(precision);
}

export function toFiat({ conversion, amount, precision }) {
  if (!isValidPrice(conversion)) return 0;
  return Decimal.mul(amount, conversion).toFixed(precision);
}

export function validateRecipientAddress({
  coin,
  address,
  isSameAddress,
  validateAddress,
}) {
  let error = false;
  let message = '';

  if (!isSameAddress) {
    throw new Error('isSameAddress is required');
  }
  if (!validateAddress) {
    throw new Error('validateAddress is required');
  }

  if (isSameAddress(address, coin.walletId)) {
    error = true;
    message = 'You cannot send funds to yourself.';
  } else {
    const isValidAddress = validateAddress(address);
    if (!isValidAddress) {
      error = true;
      message = 'Incorrect wallet address format, please try again';
    }
  }

  return { error, message };
}
